export const navHeight = 64;
export const mobileNavBreakpoint = 850;
export const forceSmallLogoBreakpoint = 1000;
export const smallLogoHeight = 36;
export const largeLogoHeight = 100;
